import { AppSettings } from "../Models/Appsettings";

let config: AppSettings | null = null;

export const loadSettings = async (): Promise<void> => {
    console.log('All env vars:', import.meta.env);
    const API_URL = import.meta.env.VITE_API_URL;
    const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

    if (!API_URL || !ENVIRONMENT) {
        throw new Error("Missing environment variables: VITE_API_URL or VITE_ENVIRONMENT is not defined.");
    }

    try {
        const response = await fetch(`${API_URL}Settings/Get/${ENVIRONMENT}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch configuration: ${response.statusText}`);
        }
        config = await response.json() as AppSettings;
    } catch (error) {
        console.error("Error loading settings:", error);
        throw new Error("Failed to load application settings.", { cause: error });
    }
};

export const getSettings = (): AppSettings => {
    if (!config) {
        throw new Error("Configuration has not been loaded");
    }
    return config;
};
